import React from "react";
import Navbar from "../components/Navbar";

const Layout = ({ children }) => {
  return (
    <div className="font-sora">
      <Navbar />
      <main>{children}</main>
    </div>
  );
};

export default Layout;
